import { Pipe, PipeTransform } from '@angular/core';
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";

@Pipe({
  name: 'filterTypes'
})
export class FilterTypesPipe implements PipeTransform {

  transform(items: IdynamicFormItem[], typesToFilter: string[] = []): any {
    return items.filter(item => item.type && !typesToFilter.includes(item.type.toString().toLowerCase()));
  }

}
